{
  "FILTER": {
    "TITLE": "会話をフィルターする",
    "SUBTITLE": "フィルターを追加して「フィルターを適用」を押すと、チャットを整理できます。",
    "EDIT_CUSTOM_FILTER": "フォルダーを編集",
    "CUSTOM_VIEWS_SUBTITLE": "フィルターを追加または削除し、フォルダーを更新します。",
    "ADD_NEW_FILTER": "フィルターを追加",
    "FILTER_DELETE_ERROR": "何も保存できないようです！保存するには、少なくとも1つのフィルターを追加してください。",
    "SUBMIT_BUTTON_LABEL": "フィルターを適用",
    "UPDATE_BUTTON_LABEL": "フォルダーを更新",
    "CANCEL_BUTTON_LABEL": "キャンセル",
    "CLEAR_BUTTON_LABEL": "フィルターをクリア",
    "FOLDER_LABEL": "フォルダー名",
    "FOLDER_QUERY_LABEL": "フォルダーのクエリ",
    "EMPTY_VALUE_ERROR": "値は必須です。",
    "TOOLTIP_LABEL": "会話をフィルターする",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "AND",
      "OR": "OR"
    },
    "INPUT_PLACEHOLDER": "値を入力",
    "CONTACT_SEARCH_PLACEHOLDER": "連絡先を検索",
    "CONTACT_FALLBACK": "Contact #{id}",
    "OPERATOR_LABELS": {
      "equal_to": "等しい",
      "not_equal_to": "等しくない",
      "does_not_contain": "含まない",
      "is_present": "存在する",
      "is_not_present": "存在しない",
      "is_greater_than": "より大きい",
      "is_less_than": "より小さい",
      "days_before": "x日前",
      "starts_with": "で始まる",
      "equalTo": "等しい",
      "notEqualTo": "等しくない",
      "contains": "含む",
      "doesNotContain": "含まない",
      "isPresent": "存在する",
      "isNotPresent": "存在しない",
      "isGreaterThan": "より大きい",
      "isLessThan": "より小さい",
      "daysBefore": "x日前",
      "startsWith": "で始まる"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "真",
      "FALSE": "偽"
    },
    "ATTRIBUTES": {
      "STATUS": "ステータス",
      "ASSIGNEE_NAME": "担当者名",
      "INBOX_NAME": "受信トレイ名",
      "TEAM_NAME": "チーム名",
      "CONTACT": "連絡先",
      "CONVERSATION_IDENTIFIER": "会話識別子",
      "CAMPAIGN_NAME": "キャンペーン名",
      "LABELS": "ラベル",
      "BROWSER_LANGUAGE": "ブラウザ言語",
      "PRIORITY": "優先度",
      "COUNTRY_NAME": "国名",
      "REFERER_LINK": "参照リンク",
      "CUSTOM_ATTRIBUTE_LIST": "リスト",
      "CUSTOM_ATTRIBUTE_TEXT": "テキスト",
      "CUSTOM_ATTRIBUTE_NUMBER": "数値",
      "CUSTOM_ATTRIBUTE_LINK": "リンク",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "チェックボックス",
      "CREATED_AT": "作成日時",
      "LAST_ACTIVITY": "最終活動日時"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "値は必須です。",
      "ATTRIBUTE_KEY_REQUIRED": "属性キーは必須です。",
      "FILTER_OPERATOR_REQUIRED": "フィルター演算子は必須です。",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "値は1から998の間でなければなりません。"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "標準フィルター",
      "ADDITIONAL_FILTERS": "追加フィルター",
      "CUSTOM_ATTRIBUTES": "カスタム属性"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "このフィルターを保存しますか？",
        "LABEL": "このフィルターに名前を付けてください",
        "PLACEHOLDER": "後で参照するためにフィルターに名前を付けてください。",
        "ERROR_MESSAGE": "名前が必須です。",
        "SAVE_BUTTON": "フィルターを保存",
        "CANCEL_BUTTON": "キャンセル",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "フォルダーが正常に作成されました。",
          "ERROR_MESSAGE": "フォルダーの作成中にエラーが発生しました。"
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "セグメントが正常に作成されました。",
          "ERROR_MESSAGE": "セグメントの作成中にエラーが発生しました。"
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "フォルダーを編集"
      },
      "DELETE": {
        "DELETE_BUTTON": "フィルターを削除",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "削除を確認",
            "MESSAGE": "本当にこのフィルターを削除しますか",
            "YES": "はい、削除します",
            "NO": "いいえ、保持します"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "フォルダーが正常に削除されました。",
          "ERROR_MESSAGE": "フォルダーの削除中にエラーが発生しました。"
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "セグメントが正常に削除されました。",
          "ERROR_MESSAGE": "セグメントの削除中にエラーが発生しました。"
        }
      }
    }
  }
}
